module.exports = __webpack_public_path__ + "img/Logo_blue@3x.6df6a354.png";